import React, { useEffect } from "react";
import {
  InfoSec,
  InfoColumn,
  InfoRow,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Img,
  InfoSecGrid,
  InfoSecSkill,
  InfoSecImg,
  InfoSecText,
  InfoSecp,
  InfoSecSkillMeta,
  InfoContainer,
} from "./AboutMe.elements";
import { TiTick } from "react-icons/ti";
import me from "../../images/fotoPersonal.jpeg";
import orla from "../../images/orla.jpg";

import Aos from "aos";
import "aos/dist/aos.css";

export default function AboutMe({ light }) {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <InfoSec id="aboutme" className="seccion" light={light}>
        <InfoContainer>
          <InfoRow
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="1000"
            data-aos-delay="600"
          >
            <InfoColumn>
              <TextWrapper light={light}>
                <TopLine>SOBRE MÍ</TopLine>
                <Heading light={light}> ALONSO DÍAZ SOBRINO</Heading>
                <Subtitle>
                 Me considero una persona atenta y
                  trabajadora, que lucha por conseguir sus objetivos sin
                  desistir. Me gusta hacer las cosas con la mayor
                  profesionalidad y organización posible para obtener buenos
                  resultados. Destacar que durante el desarrollo de la carrera
                  he mejorado la aptitud de trabajo en equipo involucrándome al
                  máximo con mis compañeros.
                </Subtitle>
                <InfoSecGrid>
                  <InfoSecSkill>
                    <InfoSecSkillMeta>
                      <InfoSecImg light={light}>
                        <TiTick />
                      </InfoSecImg>
                      <InfoSecText>Perseverancia</InfoSecText>
                    </InfoSecSkillMeta>
                    <InfoSecp>
                      Me considero firme y constante a la hora de trabajar sin
                      desistir ante cualquier tipo de problema.
                    </InfoSecp>
                  </InfoSecSkill>
                  <InfoSecSkill>
                    <InfoSecSkillMeta>
                      <InfoSecImg light={light}>
                        <TiTick />
                      </InfoSecImg>
                      <InfoSecText light={light}>Profesionalidad</InfoSecText>
                    </InfoSecSkillMeta>
                    <InfoSecp light={light}>
                      Me gusta trabajar de una forma eficaz y seria para obtener
                      buenos resultados.
                    </InfoSecp>
                  </InfoSecSkill>
                  <InfoSecSkill>
                    <InfoSecSkillMeta>
                      <InfoSecImg light={light}>
                        <TiTick />
                      </InfoSecImg>
                      <InfoSecText light={light}>Trabajo en equipo</InfoSecText>
                    </InfoSecSkillMeta>
                    <InfoSecp light={light}>
                      Me gusta trabajar en equipo de modo que haya buena
                      organización, ideas en común y constante comunicación.
                    </InfoSecp>
                  </InfoSecSkill>
                  <InfoSecSkill>
                    <InfoSecSkillMeta>
                      <InfoSecImg light={light}>
                        <TiTick />
                      </InfoSecImg>
                      <InfoSecText light={light}>Ambición</InfoSecText>
                    </InfoSecSkillMeta>
                    <InfoSecp light={light}>
                      Me considero una persona inconformista, sin límites que
                      siempre quiere más.
                    </InfoSecp>
                  </InfoSecSkill>
                </InfoSecGrid>
              </TextWrapper>
            </InfoColumn>
            <InfoColumn>
              <ImgWrapper>
                <Img src={orla} alt="Image" />
              </ImgWrapper>
            </InfoColumn>
          </InfoRow>
        </InfoContainer>
      </InfoSec>
    </>
  );
}
